import * as _ from "lodash";
import http from "../constant/api";

export const requesterService = {
  listRequesterOnline: async () => {
    const result = await http.get(`/api/requester/list/online`);

    return result;
  },
  listRequesterOffline: async () => {
    const result = await http.get(`/api/requester/list/offline`);

    return result;
  },
  countRequesterOnline: async () => {
    const result = await http.get(`/api/requester/count/online`);

    return result;
  },
  addRequester: async (data) => {
    const result = await http.post(`/api/requester/add`, data);

    return result;
  },
  editRequester: async (id, data) => {
    const result = await http.put(`/api/requester/${id}/edit`, data);

    return result;
  },
  removeRequester: async (id) => {
    const result = await http.delete(`/api/requester/${id}/remove`);

    return result;
  },
  readRequester: async (id) => {
    const result = await http.get(`/api/requester/${id}/read`);

    return result;
  },
};
